<header
  class="headerShell"
  [class.headerShell--compact]="isCompactLayout"
  [class.headerShell--collapsed]="isCompactLayout && !mobileHeaderOpen"
>
  <div class="headerTop">
    <div class="brandCluster">
      <button
        *ngIf="showMenuButton"
        type="button"
        mat-icon-button
        class="menuToggle"
        (click)="toggleMenu()"
        aria-label="Открыть навигацию"
      >
        <mat-icon>menu</mat-icon>
      </button>

      <a class="brandLink" routerLink="/new-catalog" aria-label="Autof CRM">
        <img [src]="img" alt="Autof" class="brandLogo" />
      </a>
    </div>

    <button
      *ngIf="isCompactLayout"
      type="button"
      mat-stroked-button
      class="mobileHeaderToggle"
      [attr.aria-expanded]="mobileHeaderOpen"
      aria-controls="headerActions headerCurrency headerSearch"
      (click)="mobileHeaderOpen = !mobileHeaderOpen"
    >
      <mat-icon>{{ mobileHeaderOpen ? 'expand_less' : 'search' }}</mat-icon>
      {{ mobileHeaderOpen ? 'Свернуть' : 'Поиск и действия' }}
    </button>

    <div class="headerNav" *ngIf="showTopNavigation && navigationLinks.length">
      <app-link-list [links]="navigationLinks" [orderTooltip]="orderTooltip"></app-link-list>
    </div>

    <div class="headerActions" id="headerActions">
      <button
        #dailySummaryTrigger="matMenuTrigger"
        type="button"
        [class]="shiftChipClass"
        [matMenuTriggerFor]="dailySummaryMenu"
      >
        <span class="shiftChip__icon">
          <mat-icon>today</mat-icon>
        </span>
        <span class="shiftChip__content">
          <span class="shiftChip__title">{{ shiftChipTitle }}</span>
          <span class="shiftChip__status">{{ currentMoneyDayStatusLabel }}</span>
        </span>
      </button>

      <a
        mat-flat-button
        class="headerAction headerAction--accent headerAction--iconOnly"
        routerLink="/parts-selection/new"
        routerLinkActive="headerAction--active"
        aria-label="Новый подбор, Ctrl+Alt+1"
        matTooltip="Новый подбор · Ctrl+Alt+1"
        matTooltipClass="my-tooltip"
      >
        <span class="headerAction__slot headerAction__slot--start">
          <mat-icon>assignment</mat-icon>
        </span>
        <span class="headerAction__label">Новый подбор</span>
        <span class="headerAction__slot headerAction__slot--end" aria-hidden="true"></span>
      </a>

      <a
        mat-flat-button
        class="headerAction headerAction--order headerAction--iconOnly"
        routerLink="/orders/create"
        routerLinkActive="headerAction--active"
        aria-label="Новый заказ, Ctrl+Alt+2"
        matTooltip="Новый заказ · Ctrl+Alt+2"
        matTooltipClass="my-tooltip"
      >
        <span class="headerAction__slot headerAction__slot--start">
          <mat-icon>add_shopping_cart</mat-icon>
        </span>
        <span class="headerAction__label">Новый заказ</span>
        <span class="headerAction__slot headerAction__slot--end" aria-hidden="true"></span>
      </a>

      <a
        mat-flat-button
        class="headerAction headerAction--sale headerAction--iconOnly"
        routerLink="/docs/export/create"
        routerLinkActive="headerAction--active"
        aria-label="Продажа, Ctrl+Alt+3"
        matTooltip="Продажа · Ctrl+Alt+3"
        matTooltipClass="my-tooltip"
      >
        <span class="headerAction__slot headerAction__slot--start">
          <mat-icon>point_of_sale</mat-icon>
        </span>
        <span class="headerAction__label">Продажа</span>
        <span class="headerAction__slot headerAction__slot--end" aria-hidden="true"></span>
      </a>

      <a
        mat-stroked-button
        class="headerAction headerAction--receiving headerAction--iconOnly"
        routerLink="/docs/buy/receiving"
        routerLinkActive="headerAction--active"
        aria-label="Приёмка товара, Ctrl+Alt+4"
        matTooltip="Быстрая приёмка товара · Ctrl+Alt+4"
        matTooltipClass="my-tooltip"
      >
        <span class="headerAction__slot headerAction__slot--start">
          <mat-icon>qr_code_scanner</mat-icon>
        </span>
        <span class="headerAction__label">Приёмка</span>
        <span class="headerAction__slot headerAction__slot--end" aria-hidden="true"></span>
      </a>

      <a
        mat-stroked-button
        class="headerAction headerAction--documents headerAction--iconOnly"
        routerLink="/docs/document-receiving"
        routerLinkActive="headerAction--active"
        [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
        aria-label="Приёмка документов, Ctrl+Alt+5"
        aria-keyshortcuts="Control+Alt+5"
        matTooltip="Приёмка документов · Ctrl+Alt+5"
        matTooltipClass="my-tooltip"
      >
        <span class="headerAction__slot headerAction__slot--start">
          <mat-icon>document_scanner</mat-icon>
        </span>
        <span class="headerAction__label">Приёмка документов</span>
        <span class="headerAction__slot headerAction__slot--end" aria-hidden="true"></span>
      </a>

      <app-receiving-queue-shortcut [user]="user"></app-receiving-queue-shortcut>

      <app-document-queue-shortcut [user]="user"></app-document-queue-shortcut>

      <a
        mat-stroked-button
        class="headerAction headerAction--cart headerAction--iconOnly"
        routerLink="/cart"
        routerLinkActive="headerAction--active"
        aria-label="Корзина"
        [matTooltip]="cartSummaryTooltip"
        matTooltipClass="my-tooltip"
      >
        <span class="headerAction__slot headerAction__slot--start">
          <mat-icon [matBadge]="cartProducts.length" [matBadgeHidden]="!cartProducts.length">
            shopping_cart
          </mat-icon>
        </span>
        <span class="headerAction__label">Корзина</span>
        <span class="headerAction__slot headerAction__slot--end" aria-hidden="true"></span>
      </a>

      <button
        type="button"
        mat-stroked-button
        class="userMenuTrigger"
        [matMenuTriggerFor]="toolsMenu"
        [matTooltip]="ringostatStatusLabel"
        matTooltipClass="my-tooltip"
      >
        <span class="userMenuTrigger__slot userMenuTrigger__slot--start">
          <mat-icon>account_circle</mat-icon>
          <span [class]="userMenuStatusClass" aria-hidden="true"></span>
        </span>
        <span class="userMenuTrigger__name">{{ user?.name || 'Профиль' }}</span>
        <span class="userMenuTrigger__slot userMenuTrigger__slot--end">
          <mat-icon>expand_more</mat-icon>
        </span>
      </button>
    </div>

    <div
      class="headerCurrencyRow"
      id="headerCurrency"
      *ngIf="
        currencyRatesForHeader.length ||
        currencyTrendLoading ||
        oilHistory ||
        oilHistoryLoading ||
        oilHistoryAttempted ||
        b2cPresence ||
        b2cPresenceLoading ||
        b2cPresenceError
      "
    >
      <div
        class="currencyTicker"
        [class.currencyTicker--loading]="
          (currencyTrendLoading && !currencyRatesForHeader.length) ||
          (oilHistoryLoading && !oilHistory && !oilHistoryError)
        "
      >
        <ng-container *ngIf="currencyRatesForHeader.length; else currencyTickerLoading">
          <div
            *ngFor="let rate of currencyRatesForHeader"
            [class]="getCurrencyRateClass(rate)"
            [matTooltip]="getCurrencyRateTooltip(rate)"
            matTooltipClass="my-tooltip"
          >
            <span class="currencyRate__code">{{ rate.currency }}</span>
            <span class="currencyRate__value">{{ formatCurrencyRate(rate.sale) }}</span>
            <span class="currencyRate__delta">
              <mat-icon>{{ getCurrencyTrendIcon(rate) }}</mat-icon>
              {{ formatCurrencyDelta(rate.saleDelta) }}
            </span>
          </div>
        </ng-container>
        <ng-template #currencyTickerLoading>
          <div class="currencyRate currencyRate--flat currencyRate--placeholder">
            <span class="currencyRate__code">FX</span>
            <span class="currencyRate__value">...</span>
          </div>
        </ng-template>

        <button
          *ngIf="oilHistory || oilHistoryLoading || oilHistoryAttempted"
          type="button"
          [class]="getOilRateClass()"
          [matMenuTriggerFor]="oilHistoryMenu"
          (menuOpened)="onOilHistoryMenuOpened()"
          [matTooltip]="getOilRateTooltip()"
          matTooltipClass="my-tooltip"
          aria-label="История цены Brent"
        >
          <span class="currencyRate__code">BRENT</span>
          <span class="currencyRate__value">
            {{ oilLatest ? formatOilPrice(oilLatest.price) : '...' }}
          </span>
          <span class="currencyRate__delta">
            <mat-icon>{{ getOilTrendIcon() }}</mat-icon>
            {{
              oilLatest
                ? formatCurrencyDelta(oilLatest.monthDelta)
                : oilHistoryError
                ? 'ошибка'
                : '0,00'
            }}
          </span>
        </button>

        <div
          *ngIf="b2cPresence || b2cPresenceLoading || b2cPresenceError"
          [class]="getB2cPresenceClass()"
          [matTooltip]="getB2cPresenceTooltip()"
          matTooltipClass="my-tooltip"
        >
          <span class="currencyRate__code">B2C</span>
          <span class="currencyRate__value">{{ b2cPresenceValueLabel }}</span>
          <span class="currencyRate__delta">
            <mat-icon>{{ getB2cPresenceIcon() }}</mat-icon>
            онлайн
          </span>
        </div>
        <app-procurement-attention-shortcut [user]="user"></app-procurement-attention-shortcut>
      </div>
    </div>

    <div class="headerSearchRow" id="headerSearch">
      <div class="searchModeToggle" role="group" aria-label="Режим поиска">
        <button
          type="button"
          class="searchModeToggle__btn"
          [class.searchModeToggle__btn--active]="searchMode === 'v1'"
          [attr.aria-pressed]="searchMode === 'v1'"
          (click)="setSearchMode('v1')"
          matTooltip="Текущий поиск (v1)"
        >
          v1
        </button>
        <button
          type="button"
          class="searchModeToggle__btn"
          [class.searchModeToggle__btn--active]="searchMode === 'v2'"
          [attr.aria-pressed]="searchMode === 'v2'"
          (click)="setSearchMode('v2')"
          matTooltip="Новый поиск (v2)"
        >
          v2
        </button>
      </div>
      <button
        mat-stroked-button
        type="button"
        class="productCodeSearchButton"
        (click)="openProductCodeSearch()"
        aria-haspopup="dialog"
        aria-keyshortcuts="Alt+Q"
        aria-label="Код товара, Alt+Q / Alt+Й"
        matTooltip="Поиск по коду товара · Alt+Q / Alt+Й"
      >
        <mat-icon>pin</mat-icon>
        Код товара
      </button>
      <form class="headerSearch" (ngSubmit)="search()">
        <mat-form-field class="headerSearchField">
          <mat-icon matPrefix>search</mat-icon>
          <input
            #searchInput
            matInput
            type="text"
            [formControl]="searchControl"
            [placeholder]="searchPlaceholder"
            [matAutocomplete]="searchHistoryAuto"
            (focus)="onSearchFocus()"
          />
          <mat-autocomplete
            #searchHistoryAuto="matAutocomplete"
            class="searchHistoryPanel"
            (optionSelected)="onHistoryOptionSelected()"
          >
            <div class="searchHistoryPanel__title" *ngIf="searchHistoryEntries.length">
              История поиска
            </div>
            <mat-option
              *ngFor="let entry of searchHistoryEntries; trackBy: trackByHistoryEntry"
              [value]="entry.query"
              class="searchHistoryOption"
            >
              <span class="searchHistoryOption__row">
                <mat-icon class="searchHistoryOption__icon">
                  {{ getHistoryIcon(entry.kind) }}
                </mat-icon>
                <span class="searchHistoryOption__query">{{ entry.query }}</span>
                <span class="searchHistoryOption__label" *ngIf="entry.label">
                  {{ entry.label }}
                </span>
                <span class="searchHistoryOption__meta">
                  <ng-container *ngIf="entry.userName">{{ entry.userName }} · </ng-container>
                  {{ entry.dateUpdated | date: 'dd.MM HH:mm' }}
                </span>
                <button
                  type="button"
                  class="searchHistoryOption__remove"
                  (click)="removeHistoryEntry(entry, $event)"
                  matTooltip="Удалить из истории"
                  aria-label="Удалить из истории"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </span>
            </mat-option>
          </mat-autocomplete>
          <span
            *ngIf="vinCandidate as vin"
            matSuffix
            class="searchVinBadge"
            [class.searchVinBadge--ready]="vin.isComplete"
          >
            <button
              type="button"
              class="searchVinBadge__open"
              [disabled]="!vin.isComplete"
              (click)="openLaximoCatalog(vin.vin)"
              [matTooltip]="getVinBadgeTooltip(vin)"
              aria-label="Каталог Laximo по VIN"
            >
              <mat-icon>directions_car</mat-icon>
              <span class="searchVinBadge__text">{{ vin.length }}/{{ vinLength }}</span>
            </button>
          </span>
          <span
            *ngIf="searchMode === 'v2' && searchPreview as preview"
            matSuffix
            class="searchPreviewBadge searchPreviewBadge--client"
          >
            <button
              type="button"
              class="searchPreviewBadge__open"
              (click)="openSearchPreview()"
              [matTooltip]="preview.hint || ''"
              aria-label="Открыть найденное"
            >
              <mat-icon>person</mat-icon>
              <span class="searchPreviewBadge__text">{{ preview.label }}</span>
            </button>
            <button
              type="button"
              class="searchPreviewBadge__close"
              (click)="dismissSearchPreview()"
              matTooltip="Убрать привязку"
              aria-label="Убрать привязку"
            >
              <mat-icon>close</mat-icon>
            </button>
          </span>
          <button
            *ngIf="searchControl.value"
            mat-icon-button
            matSuffix
            type="button"
            (click)="clearSearch()"
            aria-label="Очистить поиск"
          >
            <mat-icon>close</mat-icon>
          </button>
          <button mat-icon-button matSuffix type="submit" aria-label="Искать">
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </mat-form-field>
      </form>
    </div>
  </div>
</header>

<mat-menu #oilHistoryMenu="matMenu" class="oil-history-menu">
  <div class="oilHistoryPanel" (click)="$event.stopPropagation()">
    <div class="oilHistoryHead">
      <div>
        <div class="oilHistoryHead__title">Brent</div>
        <div class="oilHistoryHead__subtitle">USD за баррель</div>
      </div>
      <div class="oilHistoryHead__value">
        <span>{{ oilLatest ? formatOilPrice(oilLatest.price) : '...' }}</span>
        <small [class]="getOilDeltaClass()">
          <mat-icon>{{ getOilTrendIcon() }}</mat-icon>
          {{ oilLatest ? formatCurrencyDelta(oilLatest.monthDelta) : '0,00' }}
        </small>
      </div>
    </div>

    <div class="oilHistoryMeta">
      <span>{{ getOilTrendLabel() }}</span>
      <span *ngIf="oilLatest">{{ formatOilPercent(oilLatest.monthDeltaPercent) }}</span>
      <span *ngIf="oilLatest">Цена от {{ formatOilDate(oilLatest.date) }}</span>
    </div>

    <div class="oilHistoryTabs">
      <button
        type="button"
        (mousedown)="keepOilHistoryMenuOpen($event)"
        [class.oilHistoryTabs__button--active]="selectedOilHistoryDays === 30"
        (click)="onOilHistoryPeriodClick($event, 30)"
      >
        30
      </button>
      <button
        type="button"
        (mousedown)="keepOilHistoryMenuOpen($event)"
        [class.oilHistoryTabs__button--active]="selectedOilHistoryDays === 90"
        (click)="onOilHistoryPeriodClick($event, 90)"
      >
        90
      </button>
      <button
        type="button"
        (mousedown)="keepOilHistoryMenuOpen($event)"
        [class.oilHistoryTabs__button--active]="selectedOilHistoryDays === 365"
        (click)="onOilHistoryPeriodClick($event, 365)"
      >
        365
      </button>
    </div>

    <div class="oilHistoryChart">
      <canvas #oilHistoryChartCanvas></canvas>
      <div
        class="oilHistoryChart__empty"
        *ngIf="oilHistoryLoading && !selectedOilHistoryPoints.length"
      >
        ...
      </div>
    </div>
  </div>
</mat-menu>

<mat-menu #toolsMenu="matMenu" class="user-tools-menu">
  <div class="userToolsHeader" (click)="$event.stopPropagation()">
    <div class="userToolsHeader__name">{{ user?.name || 'Профиль' }}</div>
    <div class="userToolsHeader__caption">Рабочие инструменты</div>
  </div>

  <div class="userToolsStatus" (click)="$event.stopPropagation()">
    <div class="userToolsStatus__head">
      <span [class]="userToolsStatusDotClass" aria-hidden="true"></span>
      <div class="userToolsStatus__copy">
        <strong>{{ ringostatStatusLabel }}</strong>
        <span>Статус звонков Ringostat</span>
      </div>
    </div>

    <div class="userToolsStatus__actions">
      <button
        type="button"
        [class.userToolsStatus__button--active]="isRingostatAvailabilitySelected('online')"
        [disabled]="ringostatAvailabilitySaving || ringostatAvailabilityLoading"
        (click)="setRingostatOnline($event)"
      >
        Онлайн
      </button>
      <button
        type="button"
        [class.userToolsStatus__button--active]="isRingostatAvailabilitySelected('dnd')"
        [disabled]="ringostatAvailabilitySaving || ringostatAvailabilityLoading"
        (click)="setRingostatDnd($event)"
      >
        Не беспокоить
      </button>
    </div>

    <div class="userToolsStatus__duration">
      <span>Не беспокоить на</span>
      <button
        *ngFor="let minutes of ringostatDndMinuteOptions"
        type="button"
        [class.userToolsStatus__button--active]="isRingostatTemporaryMinutesSelected(minutes)"
        [disabled]="ringostatAvailabilitySaving || ringostatAvailabilityLoading"
        (click)="setRingostatTemporaryDnd($event, minutes)"
      >
        {{ minutes }}
      </button>
    </div>
  </div>

  <button mat-menu-item type="button" (click)="uploadFile()">
    <mat-icon>upload_file</mat-icon>
    <span>Загрузить прайс</span>
  </button>

  <button mat-menu-item type="button" (click)="printCell()">
    <mat-icon>print</mat-icon>
    <span>Печать ячейки</span>
  </button>

  <a mat-menu-item routerLink="/settings">
    <mat-icon>settings</mat-icon>
    <span>Настройки</span>
  </a>

  <a mat-menu-item routerLink="/settings/supplier_analogue_settings/list">
    <mat-icon>sync_alt</mat-icon>
    <span>Загрузка аналогов поставщиков</span>
  </a>

  <a mat-menu-item routerLink="/markup_table">
    <mat-icon>percent</mat-icon>
    <span>Наценка</span>
  </a>

  <button mat-menu-item type="button" class="userToolsLogout" (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>Выход</span>
  </button>
</mat-menu>

<mat-menu #dailySummaryMenu="matMenu" class="daily-summary-menu">
  <div class="daily-summary-popover" (click)="$event.stopPropagation()">
    <section class="summary-pending-collection" *ngIf="pendingManagerMoneyDays.length">
      <div>
        <strong>Ожидает инкассации</strong>
        <span> Новая смена откроется после завершения инкассации </span>
      </div>
      <button
        *ngFor="let pendingDay of pendingManagerMoneyDays"
        mat-stroked-button
        color="warn"
        type="button"
        (click)="openManagerMoneyDay(pendingDay)"
      >
        Смена №{{ pendingDay.id }} · {{ pendingDay.warehouse_name || 'Без склада' }}
      </button>
    </section>

    <ng-container *ngIf="!cashShiftSelectionError; else cashShiftSelectionErrorState">
      <ng-container *ngIf="selectedManagerMoneyDay as day; else managerMoneyDaysEmptyState">
        <section class="summary-section summary-section--compact-shift">
          <div class="summary-shift-head">
            <div>
              <div class="summary-shift-name">{{ day.warehouse_name || 'Без склада' }}</div>
              <div class="summary-shift-context">
                Смена №{{ day.id }} · {{ day.business_date | date: 'dd.MM.yyyy' }}
              </div>
            </div>
            <span [class]="getMoneyDayRowStatusClass(day)">
              {{ getMoneyDayRowStatusLabel(day) }}
            </span>
          </div>

          <div class="summary-cash-balance">
            <span>
              <mat-icon>account_balance_wallet</mat-icon>
              В кассе
            </span>
            <strong [ngClass]="getAmountSignClass(selectedManagerMoneyDayCashAmount)">
              {{ supportService.formatMoney(selectedManagerMoneyDayCashAmount) }}
            </strong>
          </div>

          <div class="summary-compact-list" *ngIf="selectedManagerMoneyDayTypeRows.length">
            <div class="summary-compact-list__title">Оплаты по типам</div>
            <div
              class="summary-compact-row"
              *ngFor="let row of selectedManagerMoneyDayTypeRows; trackBy: trackByMoneyTypeRow"
            >
              <span>{{ row.label }}</span>
              <strong [ngClass]="getAmountSignClass(row.value)">
                {{ supportService.formatMoney(row.value) }}
              </strong>
            </div>
          </div>

          <div class="summary-expense-row" *ngIf="selectedManagerMoneyDayExpenseAmount > 0.009">
            <span>Расходы</span>
            <strong>{{ supportService.formatMoney(selectedManagerMoneyDayExpenseAmount) }}</strong>
          </div>

          <button
            *ngIf="currentShiftRefundReport.total > 0.009"
            type="button"
            class="summary-refund-row"
            (click)="openCurrentRefundReport()"
            aria-label="Открыть возвраты по смене"
          >
            <span>Возвраты</span>
            <strong>{{ supportService.formatMoney(currentShiftRefundReport.total) }}</strong>
            <mat-icon>chevron_right</mat-icon>
          </button>

          <div
            class="summary-inline-error"
            *ngIf="shiftRefundReportsError && currentShiftRefundReport.total <= 0.009"
          >
            Возвраты не загружены
          </div>

          <div class="summary-shift-actions">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="summary-open-shift"
              (click)="openManagerMoneyDay(day)"
              [disabled]="closingManagerMoneyDayId === day.id"
            >
              Открыть
            </button>
            <button
              mat-flat-button
              color="warn"
              type="button"
              class="summary-close-shift"
              (click)="closeManagerMoneyDay(day)"
              [disabled]="closingManagerMoneyDayId === day.id"
            >
              {{ closingManagerMoneyDayId === day.id ? 'Закрываем…' : 'Закрыть смену' }}
            </button>
          </div>
        </section>
      </ng-container>
    </ng-container>

    <ng-template #cashShiftSelectionErrorState>
      <div class="summary-empty-state amount-negative">{{ cashShiftSelectionError }}</div>
    </ng-template>

    <ng-template #managerMoneyDaysEmptyState>
      <div class="summary-empty-state">
        {{ managerMoneyDaysLoading ? 'Загружаем смену…' : 'Смена не открыта' }}
      </div>
    </ng-template>
  </div>
</mat-menu>
